/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PlaylistUpdates } from './PlaylistUpdates';
import {
    PlaylistUpdatesFromJSON,
    PlaylistUpdatesFromJSONTyped,
    PlaylistUpdatesToJSON,
} from './PlaylistUpdates';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface PlaylistUpdatesResponse
 */
export interface PlaylistUpdatesResponse {
    /**
     * 
     * @type {number}
     * @memberof PlaylistUpdatesResponse
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof PlaylistUpdatesResponse
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof PlaylistUpdatesResponse
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof PlaylistUpdatesResponse
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof PlaylistUpdatesResponse
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof PlaylistUpdatesResponse
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof PlaylistUpdatesResponse
     */
    version: VersionMetadata;
    /**
     * 
     * @type {PlaylistUpdates}
     * @memberof PlaylistUpdatesResponse
     */
    data?: PlaylistUpdates;
}

/**
 * Check if a given object implements the PlaylistUpdatesResponse interface.
 */
export function instanceOfPlaylistUpdatesResponse(value: object): value is PlaylistUpdatesResponse {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function PlaylistUpdatesResponseFromJSON(json: any): PlaylistUpdatesResponse {
    return PlaylistUpdatesResponseFromJSONTyped(json, false);
}

export function PlaylistUpdatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaylistUpdatesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : PlaylistUpdatesFromJSON(json['data']),
    };
}

export function PlaylistUpdatesResponseToJSON(value?: PlaylistUpdatesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': PlaylistUpdatesToJSON(value.data),
    };
}

